<template>
  <div>
    <div>
      <v-btn icon to="/atena/usuario">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" dark class="mb-3">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-card class="pa-3 mt-3">
      <form @submit.prevent="onSubmit">
        <Input type="text" label="Nome" v-model.trim="form.nomeusuario" :v="$v.form.nomeusuario" />
        <InputMask mask="###.###.###-##" label="CPF" v-model.trim="form.documentocpf" :v="$v.form.documentocpf"/>
        <Input type="text" label="E-mail" v-model.trim="form.emailusuario" :v="$v.form.emailusuario" />
        <Input type="password" label="Senha" v-model.trim="senha" :v="$v.senha" />
        <Input type="password" label="Confirmar Senha" v-model.trim="senhaConfirmar" :v="$v.senhaConfirmar" />

        <div class="mt-3" style="text-align: right">
          <v-btn type="submit" :loading="loading" small dark color="teal" class="rounded-sm font-weight-regular" width="90px">Salvar</v-btn>
        </div>
      </form>
    </v-card>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, maxLength, integer, sameAs, email, minLength } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const AtenaUsuarioRepository = RepositoryFactory.get('atenaUsuario');

const setFormInicial = (props) => ({
  nomeusuario: '',
  emailusuario: '',
  documentocpf: '',
});

export default {
  name: 'UsuarioCadastro',
  props: {
    id: [Number, String],
  },
  data() {
    return {
      form: setFormInicial(),
      loading: false,
      msgArrayError: [],
      submitText: '',
      snackbar: false,
      senha: '',
      senhaConfirmar: '',
    };
  },
  validations() {
    return {
      form: {
        nomeusuario: { required, maxLength: maxLength(80) },
        emailusuario: { required, maxLength: maxLength(75), email },
        documentocpf: { required, minLength: minLength(11), maxLength: maxLength(11) },
      },
      senha: { required: ((typeof this.id === 'undefined')? required: ''), minLength: minLength(8) },
      senhaConfirmar: { required: ((typeof this.id === 'undefined')? required: ''), sameAs: sameAs('senha'), minLength: minLength(8) },
    };
  },
  async beforeRouteEnter(to, from, next) {
    try{
      let editar = {};
      if(to.params.id) {
        editar = await AtenaUsuarioRepository.getUsuario(to.params.id);
      }

      next(vm => {
        if(to.params.id) { vm.load(editar.data.results); }
      });
    }
    catch(e){
      next('/atena/usuario');
    }
  },
  methods: {
    load(data) {
      this.form = { ...data };
      if(this.form.documentocpf !== '') {
        this.form.documentocpf = (`00000000000${this.form.documentocpf}`).slice(-11);
      }
      this.$Progress.finish();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      try {
        this.loading = true;
        this.msgArrayError = [];
        const funcao = (this.id)? 'put' : 'post';
        const { data } = await AtenaUsuarioRepository[`${funcao}Usuario`]({
          ...this.form,
          senhausuario: this.senha,
        });

        this.submitText = data.message;
        this.snackbar = true;

        setTimeout(() => {
          this.$root.$router.push({
            path: '/atena/usuario',
          });
        }, 1000);
      } catch(error) {
        if (error.response && error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style>

</style>
